import { makeStyles } from '@rbx/ui';
import { assistantIsMobileBreakpoint } from '../constants/assistantStyleConstants';

const useExamplePromptStyles = makeStyles()((theme) => ({
  card: {
    height: '100%',
    background: theme.palette.surface[200],
    padding: theme.spacing(3),
    [theme.breakpoints.down(assistantIsMobileBreakpoint)]: {
      padding: theme.spacing(2),
    },
    position: 'relative',
  },

  cardActionArea: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  content: {
    height: '100%',
  },

  contentText: {
    flex: 1,
  },

  title: {
    marginTop: 2,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineClamp: 2,
    boxOrient: 'vertical',
    [theme.breakpoints.down(assistantIsMobileBreakpoint)]: {
      marginTop: 0,
      marginBottom: 4,
    },
    [theme.breakpoints.down('Medium')]: {
      fontSize: 16,
    },
  },

  description: {
    color: theme.palette.content.muted,
    [theme.breakpoints.down('Medium')]: {
      fontSize: 14,
    },
  },

  buildIcon: {
    padding: '3px 0',
  },

  monetizeIcon: {
    position: 'relative',
    left: -1,
  },
}));

export default useExamplePromptStyles;
